import { useEffect } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../constants/routes';
import { getCart } from '../../../reducers/cart';
import session from '../../../utils/session';
import serializeQueryParams from '../../../utils/url/serialize-query-params';
import { changeState } from '../reducers';

export default function usePaymentCartData() {
    const queryParams = serializeQueryParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const cartData = useSelector((state: RootState) => state.main.cart);

    // Step back if a same-origin page is behind us (Navigation API, else history size); else cart.
    const exitCheckout = () => {
        const { navigation } = window as unknown as { navigation?: { canGoBack: boolean } };
        const canGoBack = navigation ? navigation.canGoBack : window.history.length > 1;

        canGoBack ? navigate(-1) : navigate(ROUTES.WARENKORB.path, { replace: true });
    };

    useEffect(() => {
        if (!cartData.loaded) {
            dispatch(getCart());

            return;
        }

        if (queryParams.materialId) {
            axios
                .get(`v1/materials/${queryParams.materialId}`)
                .then((response) => {
                    const materialInfo = response.data.items[0];

                    const isFree = materialInfo.price === '0,00';
                    const isOwned = session.isLoggedIn() && Boolean(materialInfo.aclId || materialInfo.hasAclFree);
                    const canPurchaseMaterial = !isFree && !isOwned;

                    if (!canPurchaseMaterial) {
                        exitCheckout();

                        return;
                    }

                    const singleCartData = {
                        cartItems: [
                            {
                                finalPrice: materialInfo.price,
                                material: materialInfo,
                                originalPrice: materialInfo.price,
                                total: materialInfo.price
                            }
                        ],
                        finalPrice: materialInfo.price,
                        loaded: true
                    } as unknown as Cart;

                    dispatch(changeState({ paymentCart: singleCartData }));
                })
                .catch(() => {
                    exitCheckout();
                })
                .finally(() => {
                    dispatch(changeState({ isDataProcessing: false }));
                });

            return;
        }

        if (!cartData.cartItems?.length) {
            exitCheckout();

            return;
        }

        dispatch(changeState({ paymentCart: cartData }));
        dispatch(changeState({ isDataProcessing: false }));
    }, [cartData.loaded, cartData.cartItems?.length]);
}
